import {CoChannelTypeService} from "./service/api/co-channel-type.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

export const CO_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['co.CoChannelType', {route: '/co/coChannelTypes', service: CoChannelTypeService}],
            ['co.CoChannelTypeContactType', {
                route: '/co/coChannelTypeContactTypes'
            }],
        ] as EntityServiceEntry[],
        multi: true
    }
];
